module.exports = __webpack_public_path__ + "img/p4.20f15d7c.png";